import { DocumentTextIcon, QueueListIcon } from "@heroicons/react/24/outline";
import { unwrapConnection } from "@utils/utils";

import {
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from "@fronterahealth/frontera-ui-components/ui/dropdown-menu";

import { ReportSectionFieldsType, ReportSectionsType } from "@api/graphql/types-and-hooks";
import { useMoveFieldToSection } from "@components/ReportField/ReportFieldDropdownMenu/useMoveFieldToSection";
import { APPENDIX_PAGE_LOCATION, orderedAssessmentSubRoutes, routeLabelMapping } from "@components/ReportField/consts";
import { InitialAssessmentPageRoute } from "@pages/AssessmentReportV2Details/types";
import { useReport } from "@providers/ReportProvider";

interface Props {
  section: ReportSectionsType;
  field: ReportSectionFieldsType;
}

export const ReportFieldDropdownMenuMoveToSection: React.FC<Props> = ({ section, field }) => {
  const { report } = useReport();
  const moveToSectionMutate = useMoveFieldToSection();

  const reportSections = unwrapConnection(report.reportSections) ?? [];
  const pageLocations = [...new Set(reportSections.map((item) => item.pageLocation))]
    .filter((location) => location !== APPENDIX_PAGE_LOCATION)
    .sort((a, b) => orderedAssessmentSubRoutes.indexOf(a) - orderedAssessmentSubRoutes.indexOf(b));

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        <QueueListIcon />
        Move to Section
      </DropdownMenuSubTrigger>
      <DropdownMenuPortal>
        <DropdownMenuSubContent>
          {pageLocations.map((page) => {
            const sectionsForPage = reportSections
              .filter((target) => target.pageLocation === page)
              .sort((a, b) => a.rankOrder - b.rankOrder);
            return (
              <DropdownMenuGroup key={page}>
                <DropdownMenuLabel>{routeLabelMapping[page as InitialAssessmentPageRoute] || page}</DropdownMenuLabel>
                {sectionsForPage.map((target) => (
                  <DropdownMenuItem
                    key={target.id}
                    disabled={section.id === target.id}
                    onClick={() => moveToSectionMutate({ fieldId: field.id, targetSectionId: target.id })}
                  >
                    <DocumentTextIcon />
                    {target.title}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuGroup>
            );
          })}
          {!reportSections.length && <DropdownMenuItem disabled>No Section Found</DropdownMenuItem>}
        </DropdownMenuSubContent>
      </DropdownMenuPortal>
    </DropdownMenuSub>
  );
};
